import apiClient from "../config/apiClient";


export const updatePatient = async (data) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.put(`/public/portal?url=patient/${data?.id}?enroll=0`, data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };

  export const updateUserProfile = async (patient_id, data) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.put(`/public/portal?url=patient/${patient_id}?enroll=0`, data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
  // patient/3242?enroll=0